<template>
  <div>
    <v-toolbar dense color="grey lighten-3" flat>
      <v-icon>mdi-view-list </v-icon>
      <v-toolbar-title>Marine Voyage Details </v-toolbar-title>
    </v-toolbar>
    <v-flex xs12>
      <form action="">
         <v-expansion-panels>
        <v-expansion-panel>
          <v-expansion-panel-header>
            <div>
              <v-icon>mdi-filter-variant</v-icon> Filters
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card>
              <v-card-text>
                <v-container fluid grid-list-lg>
                  <v-layout row wrap>
                    <v-flex md6>
                      <v-text-field v-model="filters.paramType" :label="labels.paramType" :error-messages="errors.collect('paramType')" data-vv-name="paramType" :data-vv-as="labels.paramType"></v-text-field>
                    </v-flex>
                    <v-flex md6>
                      <v-text-field v-model="filters.paramDesc" :label="labels.paramDesc" :error-messages="errors.collect('paramDesc')" data-vv-name="paramDesc" :data-vv-as="labels.paramDesc"></v-text-field>
                    </v-flex>
                  </v-layout>
                    <v-layout row wrap>
                    <v-flex md6>
                      <cal-picker :label="labels.estDeptDate" v-model="filters.estDeptDate" :error-messages="errors.collect('estDeptDate')" data-vv-name="estDeptDate" :data-vv-as="labels.estDeptDate"></cal-picker>
                    </v-flex>
                  </v-layout>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
              </v-card-actions>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <div>
      <v-card>
        <v-card-title>
        <!-- <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field> -->
        <v-spacer></v-spacer>
        <v-btn color="primary" dark class=" mr-2" @click="doNew">
          New Voyage Details
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
      </v-card-title>
        <v-flex xs12>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td>{{ row.item.paramName }}</td>
                <td>{{ row.item.paramType }}</td>
                <td>{{ row.item.paramDesc }}</td>
                <td>{{ formatDisplayDateTime2(row.item.estDeptDate) }}</td>
                <td class="table-action-header">
                  <table-action :rowData="row" review @review="doReview(row.item.paramName, row.item.paramType)" query @query="doQuery(row.item.paramName, row.item.paramType)" remove @remove="doPromptRemove(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
      </v-card>
    <!--Start Delete Prompt -->
    <confirm v-model="promptRemove" @ok="doDelete">
      <p>{{labels.promptRemove}}</p>
      <div class="queryValue">{{selected.paramName}}, {{selected.paramType}}, {{selected.paramDesc}}</div>
    </confirm>
    <!-- End Delete Prompt-->
    </div>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { marineDataMixin } from '@/mixins/params/marineDataMixin'
import { formatDisplayDate, formatDisplayDateTime2 } from '@/utils/date'
// , removeTime
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'

export default {
  data() {
    return {
      marineParam: 'vslVoy',
      toogleArray: [false],
      headers: [
        { text: 'Vessel No.', value: 'paramName' },
        { text: 'Voyage No.', value: 'paramType' },
        { text: 'Description', value: 'paramDesc' },
        { text: 'Estimated Departure Date', value: 'estDeptDate' },
        TableConst.tableActionHeader
      ],
      labels: {
        paramName: 'Vessel No.',
        paramType: 'Voyage No',
        paramDesc: 'Voyage Details',
        estDeptDate: 'Estimated Departure Date',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        promptRemove: 'Are you sure you want to delete the selected Marine Voyage Details?'
      },
      filters: {
        paramType: undefined,
        paramDesc: undefined,
        estDeptDate: undefined
      },
      totalItems: 0,
      loading: false,
      deleteProp: undefined,
      selected: {
        paramName: null,
        paramType: null,
        paramDesc: null,
        estDeptDate: null
      },
      promptRemove: false,
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  watch: {
    'pagination': function(value) {
      this.doGetInit(false)
    }
  },
  methods: {
    init() {
      this.doInit(this.marineParam)
    },
    formatDisplayDate(value) {
      return formatDisplayDate(value)
    },
    formatDisplayDateTime2(xdate) {
      return formatDisplayDateTime2(xdate)
    },
    doNew() {
      this.$router.push({ name: 'vslVoyReview', params: { vesselVoyMode: 'create', paramName: this.vsl, vsl: this.vsl, detReview: this.detReview } })
    },
    doQuery(paramName, paramType) {
      this.$router.push({ name: 'vslVoyReview', params: { vesselVoyMode: 'query', paramName: paramName, paramType: paramType, vsl: this.vsl, detReview: this.detReview } })
    },
    async doReview(paramName, paramType) {
      this.$router.push({ name: 'vslVoyReview', params: { vesselVoyMode: 'review', paramName: paramName, paramType: paramType, vsl: this.vsl, detReview: this.detReview } })
    },
    doPromptRemove(item) {
      if (item) {
        this.selected.paramName = item.paramName
        this.selected.paramType = item.paramType
        this.selected.paramDesc = item.paramDesc
        this.selected.estDeptDate = item.estDeptDate
        this.promptRemove = true
      }
    },
    async doDelete() {
      this.resetMessages()
      if (this.selected && this.selected.paramName) {
        const apiURI = this.menu.deleteVsl
        if (apiURI) {
          const expand = {
            actionKey: 'vslVoy',
            paramName: this.selected.paramName,
            paramType: this.selected.paramType,
            paramDesc: this.selected.paramDesc,
            estDeptDate: this.selected.estDeptDate
          }
          this.$http.post(apiURI, expand).then(result => {
            const data = result.data
            this.notify(data)
            this.promptRemove = false
            this.doGetInit()
          }).catch(err => {
            this.promptRemove = false
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
        }
      }
    },
    async doGetInit(options) {
      const apiURI = this.menu.getVslVoyList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let currFilters = clone(this.filters)
          if (currFilters.estDeptDate) {
            currFilters.estDeptDate = formatDisplayDateTime2(currFilters.estDeptDate)
          }
          const result = await this.$http.get(filterQuery(expandURI(apiURI, expand), currFilters, this.pagination.sortBy, this.pagination.sortDesc))
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map(datamap => {
                const convertList = {
                  paramName: datamap.vesNo,
                  paramType: datamap.voyNo,
                  paramDesc: datamap.voyDet,
                  estDeptDate: datamap.estDeptDate
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filters.paramType = undefined
      this.filters.paramDesc = undefined
      this.filters.estDeptDate = undefined
      this.pagination.page = 1
      this.doGetInit(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then(result => {
        if (result) {
          this.pagination.page = 1
          this.doGetInit(false)
        }
      })
    }
  },
  computed: {
    menu() {
      return this.$store.state.marineParam.menu
    }
  },
  created() {
  },
  async mounted() {
    this.filters.paramName = this.vsl
    this.doGetInit(true)
  },
  mixins: [
    TableConst.default,
    marineDataMixin
  ],
  props: ['vsl', 'detReview']
}
</script>
